(function ($) {
    var searchHtml = $(".redesign-21 .banner-fourth-level .wrapper .row-wrap .list-block .search-wrap").html();
    $(window).on('load resize', function () {
        // $(".redesign-21 .banner-fourth-level").css({
        //     "opacity": 1
        // });
        if (searchHtml != undefined) {
            var windowWidth = $(window).width();
            if (windowWidth < 768) {
                $(".redesign-21 .banner-fourth-level .wrapper .title .search-wrap").remove();
                $(".redesign-21 .banner-fourth-level .wrapper .title").append($("<div class='search-wrap'>" + searchHtml + "</div>"));
                $(".redesign-21 .banner-fourth-level .wrapper .row-wrap .list-block .search-wrap").empty()
            }
            if (windowWidth > 767) {
                $(".redesign-21 .banner-fourth-level .wrapper .title .search-wrap").remove();
                $(".redesign-21 .banner-fourth-level .wrapper .row-wrap .list-block .search-wrap").remove();
                $(".redesign-21 .banner-fourth-level .wrapper .row-wrap .list-block").prepend($("<div class='search-wrap'>" + searchHtml + "</div>"));
            }
        }

    });
})(jQuery);